import React, { useState } from "react";
import styles from "../../Application.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";

function VarOnly({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const renderSection = (title, items) => {
    return (
      <div className={styles.info_section}>
        {title && (
          <>
            <div className={styles.section_title}>
              <h5>{title}</h5>
            </div>
            <div className={styles.desktop_heading}>
              <HeadingWithLine text={title} />
            </div>
          </>
        )}
        <div className={styles.info_grid}>
          {items.map((item, index) => (
            <div key={index} className={styles.info_item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          ))}
        </div>
        <ul className={styles.desktop_list}>
          {items.map((item, index) => (
            <li key={index}>
              <div>
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const getVarOnlyItems = () => {
    if (!appData?.var_only) {
      return [{ label: "", value: "Var Only Information not Available" }];
    }

    const items = [
      { label: "Type", value: appData?.var_only?.equipment_type || "-" },
    ];

    if (appData.var_only.equipment_type === "terminal") {
      items.push(
        { label: "Model", value: appData?.var_only?.terminal_model || "-" },
        { label: "Serial", value: appData?.var_only?.terminal_serial || "-" }
      );
    } else {
      items.push({ label: "Gateway", value: appData?.var_only?.gateway_name || "-" });
    }

    return items;
  };

  const varOnlyItems = getVarOnlyItems();

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.var_only} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={isMobile ? styles.business_info_header : styles.head} onClick={toggleExpanded}>
        {isMobile ? (
          <>
            <CaretRight24 className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`} />
            <h4>Var Only</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Var Only</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && renderSection(null, varOnlyItems)}
      </div>
    </div>
  );
}

export default VarOnly;
